export default __webpack_public_path__ + "static/media/splitEstate.aa76bc65.webp";